import { render, staticRenderFns } from "./CrimeHeatmap.vue?vue&type=template&id=13b5efac&"
import script from "./CrimeHeatmap.vue?vue&type=script&lang=js&"
export * from "./CrimeHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./CrimeHeatmap.vue?vue&type=style&index=0&id=13b5efac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports